import {createSlice} from "@reduxjs/toolkit";
import config from "../../config";

const user = createSlice({
	name: "user",
	initialState: {
		loading: false,
		error: null,
		filter:{
			role: undefined,
			page : 1,
			limit : config.api.limit,
		},
		items: [],
		pagination : {
			page : 1,
			limit : config.api.limit,
			totalRows: 0
		}
	},
	reducers: {
		fetchData(state) {
			state.loading = true;
			state.error = null;
			return state;
		},
		fetchDataSuccess(state, action) {
			state.loading = false;
			state.items = action.payload.data;
			state.pagination = action.payload.pagination;
			state.error = null;
			return state;
		},
		fetchDataFailed(state, action) {
			state.loading = false;
			state.error = action.payload;
			return state;
		},
		add(state, action) {
			state.items.unshift(action.payload);
			return state;
		},
		update(state, action) {
			action.payload.id = parseInt(action?.payload?.id);
			let objIndex = state.items.findIndex((item => item.id === action.payload.id));
			state.items[objIndex] = {...state.items[objIndex], ...action.payload};
			return state;
		},
		delete(state, action) {
			action.payload = parseInt(action?.payload);
			state.items = state.items.filter(function(item) {
				return item.id !== action.payload
			})
		},
		//Action search
		setFilter(state, action) {
			state.filter = action.payload;
			return state;
		},
		setFilterWithDebounce(state, action) {}
	}
})
//Action
export const userActions = user.actions;
//Reducers
export const userReducer = user.reducer;
//Selectors
export const userItemsSelector = (state) => state.user.items;
export const userLoadingSelector = (state) => state.user.loading;
export const userErrorSelector = (state) => state.user.error;
export const userFilterSelector = (state) => state.user.filter;
export const userPaginationSelector = (state) => state.user.pagination;